// components/error/ErrorPage.jsx — Itemzo işıqlı tema global xəta səhifəsi.
// Yenidən istifadə olunan mərkəzləşdirilmiş kart. Props: code/title/message/icon/
// primaryAction/secondaryAction. Preset kodları: 401/403/404/405/500/503.
import React from 'react'
import { Link } from 'react-router-dom'
import { FaLock, FaBan, FaCompass, FaExclamationTriangle, FaServer, FaTools } from 'react-icons/fa'

export const ERROR_PRESETS = {
    401: { icon: FaLock,                 title: 'Giriş tələb olunur',            message: 'Bu səhifəyə daxil olmaq üçün hesabınıza giriş edin.',                    primary: { to: '/login', label: 'Giriş et' },       secondary: { to: '/', label: 'Ana səhifə' } },
    403: { icon: FaBan,                  title: 'İcazəniz yoxdur',               message: 'Bu səhifəyə daxil olmaq üçün uyğun rol və icazə lazımdır.',              primary: { to: '/', label: 'Ana səhifə' },          secondary: { to: '/support', label: 'Dəstəyə yaz' } },
    404: { icon: FaCompass,              title: 'Səhifə tapılmadı',              message: 'Axtardığınız səhifə mövcud deyil və ya ünvan səhv yazılıb.',             primary: { to: '/', label: 'Ana səhifə' },          secondary: { to: '/bazar', label: 'Bazara bax' } },
    405: { icon: FaExclamationTriangle,  title: 'Bu əməliyyat dəstəklənmir',     message: 'Sorğu metodu bu səhifə üçün uyğun deyil.',                               primary: { to: '/', label: 'Ana səhifə' } },
    500: { icon: FaServer,               title: 'Server xətası',                 message: 'Gözlənilməz xəta baş verdi. Zəhmət olmasa bir az sonra yenidən yoxlayın.', primary: { reload: true, label: 'Yenilə' },         secondary: { to: '/support', label: 'Dəstəyə yaz' } },
    503: { icon: FaTools,                title: 'Servis müvəqqəti əlçatan deyil', message: 'Hazırda texniki işlər və ya yüklənmə səbəbi ilə xidmət əlçatan deyil.',   primary: { reload: true, label: 'Yenilə' } },
}

const btnBase = 'inline-flex items-center justify-center rounded-xl px-5 py-2.5 text-sm font-bold transition-colors'
const btnPrimary = 'bg-gradient-to-r from-brand-600 to-indigo-600 text-white hover:from-brand-700 hover:to-indigo-700 shadow-sm shadow-brand-600/25'
const btnSecondary = 'border border-slate-200 bg-white text-slate-600 hover:border-brand-300 hover:text-brand-700'

const ActionButton = ({ action, primary }) => {
    if (!action) return null
    const cls = `${btnBase} ${primary ? btnPrimary : btnSecondary}`
    if (action.reload) return <button type='button' onClick={() => window.location.reload()} className={cls}>{action.label}</button>
    return <Link to={action.to} className={cls}>{action.label}</Link>
}

const ErrorPage = ({ code = 404, title, message, icon, primaryAction, secondaryAction }) => {
    const preset = ERROR_PRESETS[code] || ERROR_PRESETS[404]
    const Icon = icon || preset.icon
    const primary = primaryAction || preset.primary
    const secondary = secondaryAction || preset.secondary

    return (
        <div className='relative flex min-h-[70vh] items-center justify-center overflow-hidden px-4 py-16'>
            {/* yumşaq bənövşəyi aksent — konteyner içində clip olunur */}
            <div className='pointer-events-none absolute left-1/2 top-4 h-72 w-72 -translate-x-1/2 rounded-full bg-brand-200/40 blur-3xl' aria-hidden='true' />
            <div className='relative w-full max-w-md rounded-3xl border border-slate-200 bg-white p-8 text-center shadow-[0_20px_60px_rgba(124,58,237,0.10)]'>
                <div className='mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-500 to-indigo-600 text-2xl text-white shadow-sm'>
                    <Icon />
                </div>
                <p className='text-5xl font-black leading-none text-slate-900'>{code}</p>
                <h1 className='mt-3 text-lg font-bold text-slate-800'>{title || preset.title}</h1>
                <p className='mx-auto mt-2 max-w-sm text-sm leading-6 text-slate-500'>{message || preset.message}</p>
                <div className='mt-6 flex flex-wrap items-center justify-center gap-3'>
                    <ActionButton action={primary} primary />
                    <ActionButton action={secondary} />
                </div>
            </div>
        </div>
    )
}

export default ErrorPage
